import { render, staticRenderFns } from "./OrderBookData.vue?vue&type=template&id=a656b3f8"
import script from "./OrderBookData.vue?vue&type=script&lang=js"
export * from "./OrderBookData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports